import { render } from "./FileDisplay.vue?vue&type=template&id=6884e32c&scoped=true&ts=true"
import script from "./FileDisplay.vue?vue&type=script&lang=ts"
export * from "./FileDisplay.vue?vue&type=script&lang=ts"

import "./FileDisplay.vue?vue&type=style&index=0&id=6884e32c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6884e32c"]])

export default __exports__